// extracted by mini-css-extract-plugin
module.exports = {"set_drop":"ScoreModal_set_drop__3tCpw","score_div":"ScoreModal_score_div__3w3c6"};